import { createSelector } from 'reselect'
import entityUidSelector from './creation_tool_entity_uid_selector'

export default createSelector(
	[
		entityUidSelector,
		state => state.matchingPairsCt.instructions.text,
		state => state.matchingPairsCt.timer.value,
	],
	(entityUid, instructionsText, timerValue) => ({
		mpUID: entityUid,
		instructionsValue: instructionsText,
		timerValue,
	})
)
